import { render, staticRenderFns } from "./segment-row.vue?vue&type=template&id=08da86a6&"
import script from "./segment-row.vue?vue&type=script&lang=js&"
export * from "./segment-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports